import { html } from "lit";

export default html`
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      d="M12 14.875a.625.625 0 1 1 0 1.25H7.5c-1.44 0-2.023.007-2.48.145a3.375 3.375 0 0 0-2.25 2.25c-.138.457-.145 1.04-.145 2.48a.625.625 0 1 1-1.25 0c0-1.35-.007-2.164.2-2.843a4.625 4.625 0 0 1 3.082-3.083c.68-.206 1.493-.199 2.843-.199H12Zm9.558.683a.626.626 0 0 1 .884.884l-4 4a.626.626 0 0 1-.884 0l-2-2a.626.626 0 0 1 .884-.884L18 19.115l3.558-3.557Z"
    />
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M10 2.375a5.125 5.125 0 1 1 0 10.25 5.125 5.125 0 0 1 0-10.25Zm0 1.25a3.875 3.875 0 1 0 0 7.75 3.875 3.875 0 0 0 0-7.75Z"
      clip-rule="evenodd"
    />
  </svg>
`;
